import { toast } from 'react-toastify';
import {
  approveOrRejectRemuneration,
  getCandidateRemuneration,
} from '../../features/remunerationSlice';
import { CLICK_ACTIONS } from '../../utils/Constant';
import { ColumnHeaderType, RemunerationFilterType } from '../../utils/Types';
import {
  blankValueGetter,
  formattedDateWithFormat,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import { ThunkDispatch } from 'redux-thunk';

export const ViewRemunerationHeader: ColumnHeaderType[] = [
  {
    name: 'Employee Id',
    field: 'employeeUniqueId',
    sortable: false,
    showProfilePhoto: true,
    valueGetter: blankValueGetter,
    clickable: true,
    action: CLICK_ACTIONS.VIEW_REMUNERATION,
  },
  {
    name: 'Employee Name',
    field: 'candidateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Role',
    field: 'roleNames',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneId',
    sortable: false,
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    name: 'State',
    field: 'stateId',
    clickable: false,
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    name: 'Last Approved On',
    field: 'lastApprovedOn',
    clickable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Action',
    field: 'action',
    clickable: true,
    action: CLICK_ACTIONS.APPROVE,
    value: 'Approve',
  },
];

export const onTableAction = (
  params: { data: any; header: any },
  setShowLoader: (isLoading: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  selectedFilterData: RemunerationFilterType,
  getRemunerationListData: () => void,
  setSelectedRemunerationDetails: (value: any) => void,
  setIsApproveModalOpen: (value: boolean) => void
) => {
  const { data, header } = params;
  setShowLoader(true);
  if (header.value === 'Approve') {
    dispatch(
      approveOrRejectRemuneration({
        candidateId: [data.candidateId],
        status: 0,
        comments: '',
        approvedMonth: formattedDateWithFormat(
          String(selectedFilterData.duration),
          'MM-YYYY'
        ),
      })
    )
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          getRemunerationListData();
        }
      })
      .catch(() => {
        setShowLoader(false);
        toast.error('Getting candidate remuneration details failed');
      });
  } else {
    dispatch(
      getCandidateRemuneration({
        candidateId: data.candidateId,
        durationMonth: formattedDateWithFormat(
          String(selectedFilterData.duration),
          'MM-YYYY'
        ),
      })
    )
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled.payload)) {
          setSelectedRemunerationDetails(fulfilled.payload.result);
          setIsApproveModalOpen(true);
        }
      })
      .catch(() => {
        setShowLoader(false);
        toast.error('Getting candidate remuneration details failed');
      });
  }
};

export const toggleApproveModal = (
  action: string,
  getRemunerationListData: () => void,
  setIsApproveModalOpen: (value: boolean) => void
) => {
  if (action === CLICK_ACTIONS.REFRESH_LIST) {
    getRemunerationListData();
  }
  setIsApproveModalOpen(false);
};
